import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import lazyPlugin from 'vue3-lazy';

import 'material-icons/iconfont/material-icons.css';
import '@/assets/main.scss';

createApp(App)
	.use(router)
	.use(lazyPlugin, {})
	.mount('#app');
